import {
  TextField as MuiTextField,
  TextFieldProps as MuiTextFieldProps, Typography
} from '@material-ui/core';
import { FieldLabel } from '../fieldLabel/fieldLabel';
import { withTestDataAttribute } from '../testDataAttribute';
import { KeyboardEventHandler } from 'react';
import React from 'react';

export type TextFieldProps = MuiTextFieldProps & {
  standaloneLabel?: boolean;
  subLabel?: string;
  testId: string;
  tooltip?: string;
};

export const TextField = withTestDataAttribute((props: TextFieldProps) => {
  const { standaloneLabel, subLabel, tooltip, onKeyDown, ...muiComponentProps } = props;

  const defaultKeyDownHandler: KeyboardEventHandler = (e: any) => {
    e.stopPropagation();
  }

  return (
    <>
      {standaloneLabel && muiComponentProps.label ? (
        <FieldLabel tooltip={tooltip}>
          {muiComponentProps.label}
          {props.required && ' *'}
        </FieldLabel>
      ) : null}
      {subLabel && (
        <FieldLabel style={{ fontSize: '.8rem', color: '#aaa' }}>
          {subLabel}
        </FieldLabel>
      )}
      <MuiTextField
        onKeyDown={onKeyDown ? onKeyDown : defaultKeyDownHandler}
        {...muiComponentProps}
        label={standaloneLabel ? undefined : muiComponentProps.label}
      />
    </>
  );
});
